import RatingSummaryProvider from './hooks/useRatingSummary';
import './RatingSummary.scss';
import { RatingSummaryProps } from './@types/RatingSummaryProps';

const RatingSummary = (props: RatingSummaryProps) => (
	<RatingSummaryProvider {...props}>
		<div
			data-selection={props.componentId}
			className={`inlineContainer vtex-reviews-and-ratings-3-x-inlineContainer vtex-reviews-and-ratings-3-x-inlineContainer--${props.blockClass}  inlineContainer--${props.blockClass} review-summary mw8 center`}
		>
			<span className="t-heading-4 v-mid">
				<span className="stars vtex-reviews-and-ratings-3-x-stars c-action-primary">
					<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
						☆
					</span>
					<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
						☆
					</span>
					<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
						☆
					</span>
					<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
						☆
					</span>
					<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
						☆
					</span>
				</span>
			</span>
			<span className="summaryTotalReviews vtex-reviews-and-ratings-3-x-summaryTotalReviews review__rating--count dib v-mid">
				(0)
			</span>
		</div>
	</RatingSummaryProvider>
);

export default RatingSummary;
